
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("bW1er", function(module, exports) {
$parcel$export(module.exports, "default", () => $32f6419a16621dc9$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $7ddQu = parcelRequire("7ddQu");

var $dMfNK = parcelRequire("dMfNK");

var $5av15 = parcelRequire("5av15");

var $2tf2A = parcelRequire("2tf2A");

var $ln1kt = parcelRequire("ln1kt");
const $32f6419a16621dc9$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $fc4bM.useEffect)(()=>{
        if (!emojiId) return;
        (0, $7ddQu.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $5av15.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $dMfNK.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $7ddQu.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ln1kt.UfoErrorBoundary), {
        experiences: [
            (0, $dMfNK.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2tf2A.ResourcedEmojiComponent), props));
};
var $32f6419a16621dc9$export$2e2bcd8739ae039 = $32f6419a16621dc9$var$ResourcedEmoji;

});
parcelRegister("7ddQu", function(module, exports) {
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $bb093437a7bd26ce$export$71c8cba6f1251ea9);

var $dMfNK = parcelRequire("dMfNK");

var $c55iO = parcelRequire("c55iO");
const $bb093437a7bd26ce$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $c55iO.withSampling)((0, $dMfNK.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};

});

parcelRegister("2tf2A", function(module, exports) {
$parcel$export(module.exports, "ResourcedEmojiComponent", () => $7df45b46bbb20065$export$7bfde52eceb3e2f6);
/* ResourcedEmojiComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ /* ResourcedEmojiComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $cZGOL = parcelRequire("cZGOL");

var $hHTMQ = parcelRequire("hHTMQ");

var $fhv13 = parcelRequire("fhv13");

var $1f7LO = parcelRequire("1f7LO");

var $7ddQu = parcelRequire("7ddQu");

var $5av15 = parcelRequire("5av15");

var $eriBW = parcelRequire("eriBW");

var $gGEtj = parcelRequire("gGEtj");

var $gV0vd = parcelRequire("gV0vd");
const $7df45b46bbb20065$var$ignoreWrapperStyles = null;
const $7df45b46bbb20065$var$isMdpiImageURL = (imageURL)=>{
    try {
        return new URL(imageURL, 'https://emoji.invalid').searchParams.get('scale') === 'MDPI';
    } catch  {
        return false;
    }
};
var $7df45b46bbb20065$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($7df45b46bbb20065$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $7df45b46bbb20065$export$7bfde52eceb3e2f6 = ({ emojiProvider: emojiProvider, emojiId: emojiId, emojiProviderLookupOrder: emojiProviderLookupOrder, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $5av15.defaultEmojiHeight), ignoreWrapper: ignoreWrapper = false, optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji, pageTitleEmoji: pageTitleEmoji = false, placeholderXcss: placeholderXcss, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $fc4bM.useState)();
    const [loaded, setLoaded] = (0, $fc4bM.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $fc4bM.useState)(false);
    const [failedAdaptiveImageURL, setFailedAdaptiveImageURL] = (0, $fc4bM.useState)();
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $fc4bM.useState)();
    const fetchOrGetEmoji = (0, $fc4bM.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            setEmoji(undefined);
            const reason = 'missing fetchByEmojiId interface';
            onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
            (0, $7ddQu.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: reason,
                    source: 'ResourcedEmojiComponent'
                }
            });
        }
        const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch, (0, $dRkX9.fg)('platform_bitbucket_fix_shortname_and_ordering') ? emojiProviderLookupOrder : undefined);
        (0, $7ddQu.sampledUfoRenderedEmoji)(emojiId).mark((0, $fhv13.UfoEmojiTimings).METADATA_START);
        if ((0, $eriBW.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    const reason = 'failed to find';
                    onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                    // emoji is undefined
                    (0, $7ddQu.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: reason,
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const reason = 'failed to load';
                onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                (0, $7ddQu.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: reason,
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $7ddQu.sampledUfoRenderedEmoji)(emojiId).mark((0, $fhv13.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $7ddQu.sampledUfoRenderedEmoji)(emojiId).mark((0, $fhv13.UfoEmojiTimings).METADATA_END);
        }
    }, [
        emojiProviderLookupOrder,
        onEmojiLoadFail
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $1f7LO.hasUfoMarked)((0, $7ddQu.sampledUfoRenderedEmoji)(emojiId), (0, $fhv13.UfoEmojiTimings).FMP_END)) (0, $7ddQu.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]);
    // Fetching during render means a render React later discards (for example a pass that suspends)
    // still creates a promise whose callbacks set state and schedule yet another render. This layout
    // effect only runs for committed renders, and being pre-paint it keeps the synchronous cache-hit
    // path from flashing the placeholder.
    (0, $fc4bM.useLayoutEffect)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]);
    /**
   * Setting resolved emoji provider for optimistic rendering
   */ (0, $fc4bM.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $fc4bM.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError
    ]);
    const optimisticEmojiDescription = (0, $fc4bM.useMemo)(()=>{
        if (optimisticImageURL && emoji && (emoji.type === 'STANDARD' || emoji.type === 'ATLASSIAN') && fitToHeight * Math.max(1, (0, $cZGOL.getPixelRatio)()) > 32 && $7df45b46bbb20065$var$isMdpiImageURL(optimisticImageURL) && (0, $dRkX9.fg)('platform_emoji_adaptive_image_size')) return emoji;
        // reduce blast radius by targeting page title
        if (pageTitleEmoji && optimisticImageURL && (0, $dRkX9.fg)('platform_emoji_prevent_img_src_changing')) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $5av15.defaultEmojiHeight),
                width: fitToHeight || (0, $5av15.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
        // Keep the optimistic representation stable when catalogue data arrives.
        if (optimisticImageURL) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $5av15.defaultEmojiHeight),
                width: fitToHeight || (0, $5av15.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
        if ((0, $dRkX9.fg)('platform_emoji_adaptive_image_size') && emoji && (emoji.type === 'STANDARD' || emoji.type === 'ATLASSIAN') && emoji.representation && 'imagePath' in emoji.representation && emoji.representation.height > 32 && fitToHeight > 0 && fitToHeight * Math.max(1, (0, $cZGOL.getPixelRatio)()) <= 32) {
            var _resolvedEmojiProvide;
            const imageURL = resolvedEmojiProvider === null || resolvedEmojiProvider === void 0 || (_resolvedEmojiProvide = resolvedEmojiProvider.getOptimisticImageURL) === null || _resolvedEmojiProvide === void 0 ? void 0 : _resolvedEmojiProvide.call(resolvedEmojiProvider, {
                id: id,
                shortName: shortName,
                fallback: fallback
            });
            // MDPI standard/Atlassian images are 32px. Reuse the provider's URL instead of
            // downloading a larger catalogue image when those pixels already cover the display.
            if (imageURL && imageURL !== failedAdaptiveImageURL && $7df45b46bbb20065$var$isMdpiImageURL(imageURL)) return {
                ...emoji,
                representation: {
                    imagePath: imageURL,
                    width: 32,
                    height: 32
                },
                altRepresentation: undefined
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName,
        pageTitleEmoji,
        resolvedEmojiProvider,
        failedAdaptiveImageURL
    ]);
    const handleOnLoadError = (0, $fc4bM.useCallback)((emojiId)=>{
        if ((0, $dRkX9.fg)('platform_emoji_adaptive_image_size') && !optimisticImageURL && optimisticEmojiDescription !== emoji && optimisticEmojiDescription !== null && optimisticEmojiDescription !== void 0 && optimisticEmojiDescription.representation && 'imagePath' in optimisticEmojiDescription.representation) {
            setFailedAdaptiveImageURL(optimisticEmojiDescription.representation.imagePath);
            return;
        }
        setImageLoadError(true);
        const reason = 'load error';
        onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
        (0, $7ddQu.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: reason,
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id
            }
        });
    }, [
        onEmojiLoadFail,
        optimisticImageURL,
        optimisticEmojiDescription,
        emoji
    ]);
    const handleOnLoadSuccess = (0, $fc4bM.useCallback)((emojiId)=>{
        onEmojiLoadSuccess && onEmojiLoadSuccess(emojiId.id);
    }, [
        onEmojiLoadSuccess
    ]);
    // use width: auto when fitToHeight is defined
    const autoWidth = !!fitToHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hHTMQ.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        "data-emoji-id": id,
        "data-emoji-short-name": shortName,
        "data-emoji-text": fallback || shortName,
        "data-ssr-placeholder": `emoji-${id ?? shortName}`,
        "data-ssr-placeholder-replace": `emoji-${id ?? shortName}`,
        className: (0, $2R2iS.default)([
            ignoreWrapper && "_1e0c1bgi"
        ])
    }, emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gV0vd.default), {
        shortName: shortName,
        showTooltip: showTooltip,
        size: fitToHeight || (0, $5av15.defaultEmojiHeight),
        loading: true,
        xcss: placeholderXcss
    }), emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, customFallback || fallback || shortName), emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gGEtj.default), {
        emoji: optimisticEmojiDescription,
        onLoadError: handleOnLoadError,
        onLoadSuccess: handleOnLoadSuccess,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        autoWidth: autoWidth,
        editorEmoji: editorEmoji
    })));
};
var $7df45b46bbb20065$export$2e2bcd8739ae039 = $7df45b46bbb20065$export$7bfde52eceb3e2f6;

});
parcelRegister("hHTMQ", function(module, exports) {
$parcel$export(module.exports, "EmojiCommonProvider", () => $e1e27d68d577f548$export$1120e666998e21b5);

var $fc4bM = parcelRequire("fc4bM");

var $jx4Dm = parcelRequire("jx4Dm");
const $e1e27d68d577f548$export$1120e666998e21b5 = (props)=>{
    const emojiContextValue = (0, $fc4bM.useMemo)(()=>props.emojiProvider ? {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        } : undefined, [
        props.emojiProvider
    ]);
    if (!!emojiContextValue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jx4Dm.EmojiContextProvider), {
        emojiContextValue: emojiContextValue
    }, props.children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, props.children);
};

});
parcelRegister("jx4Dm", function(module, exports) {
$parcel$export(module.exports, "EmojiContextProvider", () => $8f007f8a7e390f34$export$f4a09143833145ed);

var $fc4bM = parcelRequire("fc4bM");

var $hsPKy = parcelRequire("hsPKy");

var $fGr53 = parcelRequire("fGr53");
const $8f007f8a7e390f34$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $fc4bM.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $fc4bM.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await (memoizedEmojiContextValue === null || memoizedEmojiContextValue === void 0 ? void 0 : memoizedEmojiContextValue.emoji.emojiProvider.fetchEmojiProvider());
            } catch (error) {
                (0, $hsPKy.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue !== null && memoizedEmojiContextValue !== void 0 && memoizedEmojiContextValue.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue === null || memoizedEmojiContextValue === void 0 ? void 0 : memoizedEmojiContextValue.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fGr53.EmojiContext).Provider, {
        value: memoizedEmojiContextValue
    }, children);
};

});
parcelRegister("fGr53", function(module, exports) {
$parcel$export(module.exports, "EmojiContext", () => $791db348aa6a549d$export$9fab6c37a453c65e);

var $fc4bM = parcelRequire("fc4bM");
const $791db348aa6a549d$export$9fab6c37a453c65e = (0, $fc4bM.createContext)(null);

});



parcelRegister("1f7LO", function(module, exports) {
$parcel$export(module.exports, "hasUfoMarked", () => $180672a8e601ff33$export$a9be054d2a5cedc0);
const $180672a8e601ff33$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};

});

parcelRegister("gGEtj", function(module, exports) {
$parcel$export(module.exports, "EmojiNodeWrapper", () => $dd98dd18beb8b225$export$ce5eef59d8e46687);
$parcel$export(module.exports, "default", () => $dd98dd18beb8b225$export$2e2bcd8739ae039);
/* Emoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $aEmSo = parcelRequire("aEmSo");

var $bcTS3 = parcelRequire("bcTS3");

var $fhv13 = parcelRequire("fhv13");

var $1f7LO = parcelRequire("1f7LO");

var $7ddQu = parcelRequire("7ddQu");

var $dMfNK = parcelRequire("dMfNK");

var $4V8rH = parcelRequire("4V8rH");

var $5av15 = parcelRequire("5av15");

var $eXGBK = parcelRequire("eXGBK");

var $f1CAl = parcelRequire("f1CAl");

var $ko6w5 = parcelRequire("ko6w5");

var $1My73 = parcelRequire("1My73");

var $lmsyG = parcelRequire("lmsyG");

var $el5ht = parcelRequire("el5ht");

var $hWZeB = parcelRequire("hWZeB");
const $dd98dd18beb8b225$var$emojiSpriteContainer = null;
const $dd98dd18beb8b225$var$emojiImageContainer = null;
const $dd98dd18beb8b225$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $5av15.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $f1CAl.leftClick)(event)) {
        if (props.preventFocusOnMouseDown) event.preventDefault();
        onSelected((0, $ko6w5.toEmojiId)(emoji), emoji, event);
    }
};
const $dd98dd18beb8b225$var$handleKeyDown = (props, event)=>{
    if (!(0, $5av15.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $5av15.KeyboardKeys).Enter || event.key === (0, $5av15.KeyboardKeys).Space)) onSelected((0, $ko6w5.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $5av15.KeyboardKeys).Backspace) (0, $lmsyG.handleDelete)(props, event);
};
const $dd98dd18beb8b225$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $ko6w5.toEmojiId)(emoji), emoji, event);
};
const $dd98dd18beb8b225$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $ko6w5.toEmojiId)(emoji), emoji, event);
};
const $dd98dd18beb8b225$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $fc4bM.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, isDecorative: isDecorative, ...other } = props;
    const intl = (0, $fc4bM.useContext)((0, $fcCIH.Context));
    const isAriaLabelEmpty = editorEmoji || isDecorative;
    let ariaLabel;
    if (isAriaLabelEmpty) ariaLabel = undefined;
    else if (intl) ariaLabel = intl.formatMessage((0, $1My73.messages).changeEmojiShortnameButtonLabel, {
        shortName: emoji.name ?? emoji.shortName
    });
    else ariaLabel = emoji.shortName;
    const tooltipContent = showTooltip && (0, $aEmSo.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName || emoji.name || undefined : undefined;
    const emojiSpan = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        role: editorEmoji ? undefined : shouldBeInteractive ? 'button' : ariaLabel ? 'img' : 'presentation',
        "aria-label": ariaLabel,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            type === 'sprite' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _1e0c1o8l _jr50g2xd _ylp71o8l _pkaxgktf _1hdcgktf _109tnkob _tn8j1dpa _3naf1dpa _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y54 _491113zc" : "_2rkofajl _19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk1j28 _1e0c1o8l _s7n4nkob _v4pn1ule _tn8j1dpa _3naf1dpa _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y54 _491113zc",
            className
        ]),
        onKeyDown: (event)=>$dd98dd18beb8b225$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $dd98dd18beb8b225$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $dd98dd18beb8b225$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $dd98dd18beb8b225$var$handleFocus(props, event);
        },
        title: showTooltip && !(0, $aEmSo.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName : undefined,
        ...other
    }, children);
    if (tooltipContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
        content: tooltipContent,
        isScreenReaderAnnouncementDisabled: true,
        position: "top",
        tag: "span"
    }, emojiSpan);
    return emojiSpan;
});
const $dd98dd18beb8b225$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props;
    // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $4V8rH.useSampledUFOComponentExperience)((0, $dMfNK.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $5av15.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $fc4bM.useEffect)(()=>{
        const ufoExp = (0, $7ddQu.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $1f7LO.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $1f7LO.hasUfoMarked)(ufoExp, (0, $fhv13.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $fhv13.UfoEmojiTimings).MOUNTED_END);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $eXGBK.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hWZeB.SpriteEmoji), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $el5ht.ImageEmoji), props);
};
var $dd98dd18beb8b225$export$2e2bcd8739ae039 = $dd98dd18beb8b225$export$56cc48506ff790a;

});
parcelRegister("4V8rH", function(module, exports) {
$parcel$export(module.exports, "useSampledUFOComponentExperience", () => $af2bac67124c4bf5$export$f959821a7419dee1);

var $fc4bM = parcelRequire("fc4bM");

var $c55iO = parcelRequire("c55iO");
const $af2bac67124c4bf5$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $fc4bM.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $af2bac67124c4bf5$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            (0, $c55iO.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $af2bac67124c4bf5$var$useConstructor(()=>{
        (0, $c55iO.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};

});

parcelRegister("eXGBK", function(module, exports) {
$parcel$export(module.exports, "isSpriteRepresentation", () => $6f5f74d62e04e5a6$export$a194199d673d75de);
const $6f5f74d62e04e5a6$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);

});

parcelRegister("f1CAl", function(module, exports) {
$parcel$export(module.exports, "leftClick", () => $488003a4279283e0$export$34ebdaf2c517ae75);
function $488003a4279283e0$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}

});

parcelRegister("1My73", function(module, exports) {
$parcel$export(module.exports, "messages", () => $176118dd411202ae$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $176118dd411202ae$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Heading text shown at the top of the emoji removal confirmation dialog, prompting the user to confirm removing the selected custom emoji.'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Body text shown inside the emoji removal confirmation dialog. The placeholder {emojiShortName} will be substituted with the short name (e.g. ":smile:") of the replacement emoji.'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Label for the primary action button in the emoji removal confirmation dialog that confirms and executes the removal.'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Label for the button in the emoji picker that opens the custom emoji upload panel, allowing users to add their own emoji.'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiNameLabel: {
        id: 'fabric.emoji.name.label',
        defaultMessage: 'Emoji name',
        description: 'Label for the emoji name input field in the custom emoji upload panel'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Label for the file chooser button in the custom emoji upload panel where users select an image file for their emoji.'
    },
    emojiChooseFileDndTitle: {
        id: 'fabric.emoji.choose.file.dnd.title',
        defaultMessage: 'Select or drop an image',
        description: 'Label for the file chooser button in the custom emoji upload panel where users select or drag and drop an image file for their emoji.'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectColorButtonAriaLabelText: {
        id: 'fabric.emoji.select.color.ariaLabel',
        defaultMessage: 'Productivity emoji color selector',
        description: 'Message indicating the purpose of the color selection button and the selected color'
    },
    emojiSelectColorListAriaLabelText: {
        id: 'fabric.emoji.select.color.list.ariaLabel',
        defaultMessage: 'Productivity emoji colour selector',
        description: 'Message indicating the purpose of the productivity emoji color list selector'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Section heading shown above the emoji preview area in the custom emoji upload panel.'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Success text shown in the emoji preview area after the user uploads a new emoji image. The placeholder {emoji} will be substituted with the rendered emoji image.'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'Label for the submit button in the custom emoji upload panel that saves the new emoji to the workspace.'
    },
    createEmojiWithRovoTitle: {
        id: 'fabric.emoji.ai.create.title',
        defaultMessage: 'Create an emoji with Rovo',
        description: 'Section heading for the AI emoji generation area where users describe an emoji and generate it with AI.'
    },
    createEmojiWithRovoPromptPlaceholder: {
        id: 'fabric.emoji.ai.prompt.placeholder',
        defaultMessage: 'Describe your emoji...',
        description: 'Placeholder text for the input where the user describes the emoji they want the AI to generate.'
    },
    createEmojiWithRovoPromptAriaLabel: {
        id: 'fabric.emoji.ai.prompt.ariaLabel',
        defaultMessage: 'Describe the emoji you want to generate',
        description: 'Accessible label for the AI emoji description input field.'
    },
    createEmojiWithRovoGenerateLabel: {
        id: 'fabric.emoji.ai.generate.label',
        defaultMessage: 'Generate',
        description: 'Label for the button that triggers AI generation of the described emoji.'
    },
    createEmojiWithRovoError: {
        id: 'fabric.emoji.ai.error',
        defaultMessage: 'Something went wrong. Try a different description.',
        description: 'Inline error message shown when AI emoji generation or upload fails, prompting the user to try again.'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'Label for the button in the custom emoji upload panel that retries a previously failed upload attempt.'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'Label for the cancel button in the custom emoji upload panel that dismisses the panel without saving.'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text shown inside the emoji search input field in the emoji picker before the user types a query.'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'Accessible label for the emoji name search input field in the emoji picker, used by screen readers.'
    },
    searchResultsStatus: {
        id: 'fabric.emoji.search.status.count',
        defaultMessage: 'Found {count} emojis',
        description: 'search results status for screenreader to read out'
    },
    searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Category heading label shown in the emoji picker category bar when displaying results from a search query.'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Label for the Frequent category tab in the emoji picker, showing recently used emojis.'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Label for the People category tab in the emoji picker, showing face and person emojis.'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Label for the Nature category tab in the emoji picker, showing animal and nature emojis.'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Label for the Food and Drink category tab in the emoji picker.'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Label for the Activity category tab in the emoji picker, showing sports and activity emojis.'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Label for the Travel and Places category tab in the emoji picker, showing location and travel emojis.'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Label for the Objects category tab in the emoji picker, showing everyday object emojis.'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Label for the Symbols category tab in the emoji picker, showing symbol and sign emojis.'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Label for the Flags category tab in the emoji picker, showing country and regional flag emojis.'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Atlassian & productivity',
        description: 'Label for the Atlassian and productivity category tab in the emoji picker, showing Atlassian product and productivity emojis.'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'Label for the Your Uploads category tab in the emoji picker, showing custom emojis uploaded by the current user.'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'Label for the All Uploads category tab in the emoji picker, showing all custom emojis uploaded across the workspace.'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Error message shown in the custom emoji upload panel when the image upload fails due to an error.'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Error message shown in the custom emoji upload panel when the image upload fails because it timed out.'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiUnsupportedFileType: {
        id: 'fabric.emoji.error.unsupported.file.type',
        defaultMessage: "This file type isn't supported. Select a PNG, JPEG, or GIF to create your emoji.",
        description: 'Error message shown when the selected emoji upload file type is not supported'
    },
    emojiDuplicateName: {
        id: 'fabric.emoji.error.duplicate.name',
        defaultMessage: 'An emoji with this name exists already',
        description: 'Error message shown when the user tries to upload an emoji with a name that already exists in the custom emoji set'
    },
    emojiPickerNoResults: {
        id: 'fabric.emoji.picker.no.results',
        defaultMessage: 'No results',
        description: 'Heading shown in the emoji picker when a search query returns no matching emojis.'
    },
    emojiPickerAddCustomEmoji: {
        id: 'fabric.emoji.picker.add.custom.emoji',
        defaultMessage: 'Add custom emoji',
        description: 'Label for the button shown in the emoji picker no-results screen that opens the custom emoji upload panel.'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Accessible aria-label for the emoji picker dialog, used by screen readers to identify the picker.'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    changeEmojiShortnameButtonLabel: {
        id: 'fabric.emoji.change.shortname.button.label',
        defaultMessage: 'Change emoji, currently {shortName}',
        description: 'Aria label for the button in page title used to change emoji'
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});

parcelRegister("lmsyG", function(module, exports) {
$parcel$export(module.exports, "handleDelete", () => $4bc3f7852f908e5f$export$471c4c6c1d1a0512);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $ko6w5 = parcelRequire("ko6w5");
const $4bc3f7852f908e5f$export$471c4c6c1d1a0512 = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $ko6w5.toEmojiId)(emoji), emoji, event);
};

});

parcelRegister("el5ht", function(module, exports) {
$parcel$export(module.exports, "ImageEmoji", () => $8af1b448a413586f$export$99dfeb9d71c11788);
/* ImageEmoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $j5N6B = parcelRequire("j5N6B");

var $bcTS3 = parcelRequire("bcTS3");

var $jeVzV = parcelRequire("jeVzV");

var $e4RBv = parcelRequire("e4RBv");

var $fhv13 = parcelRequire("fhv13");

var $1f7LO = parcelRequire("1f7LO");

var $7ddQu = parcelRequire("7ddQu");

var $9H27G = parcelRequire("9H27G");

var $iK3c6 = parcelRequire("iK3c6");

var $1PflG = parcelRequire("1PflG");

var $ko6w5 = parcelRequire("ko6w5");

var $5P0Tk = parcelRequire("5P0Tk");

var $e3Az2 = parcelRequire("e3Az2");

var $9Mm2v = parcelRequire("9Mm2v");

var $gGEtj = parcelRequire("gGEtj");

var $lmsyG = parcelRequire("lmsyG");

var $coQxr = parcelRequire("coQxr");
const $8af1b448a413586f$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props;
    // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $ko6w5.toEmojiId)(emoji), emoji, event);
};
const $8af1b448a413586f$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, isDecorative: isDecorative } = props;
    const [ref, inView] = (0, $e4RBv.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $fc4bM.useMemo)(()=>(0, $7ddQu.sampledUfoRenderedEmoji)(emoji), [
        emoji
    ]);
    const classes = `${(0, $coQxr.emojiMainStyle)} ${(0, $coQxr.emojiNodeStyles)} ${selected ? (0, $coQxr.commonSelectedStyles) : ''} ${selectOnHover ? (0, $coQxr.selectOnHoverStyles) : ''} ${(0, $coQxr.emojiImage)} ${className ? className : ''} ${showDelete ? (0, $coQxr.deletableEmoji) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $jeVzV.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $iK3c6.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $1PflG.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) {
        const sizingWidth = autoWidth ? 'auto' : fitToHeight / height * width;
        // Presize image, to prevent reflow due to size changes after loading
        sizing = {
            width: sizingWidth,
            height: fitToHeight
        };
    }
    const onError = (0, $fc4bM.useCallback)((event)=>{
        $8af1b448a413586f$var$handleImageError({
            emoji: props.emoji,
            onLoadError: props.onLoadError
        }, event);
    }, [
        props.emoji,
        props.onLoadError
    ]);
    const onLoad = (0, $fc4bM.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $fhv13.UfoEmojiTimings).MOUNTED_END);
        // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $1f7LO.hasUfoMarked)(ufoExp, (0, $fhv13.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $fhv13.UfoEmojiTimings).ONLOAD_START, mountedMark === null || mountedMark === void 0 ? void 0 : mountedMark.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $fhv13.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
        // onload_start
        if (!(0, $1f7LO.hasUfoMarked)(ufoExp, (0, $fhv13.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $fhv13.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $9H27G.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $fc4bM.useCallback)(()=>{
        if (!(0, $1f7LO.hasUfoMarked)(ufoExp, (0, $fhv13.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $fhv13.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $fc4bM.useCallback)((e)=>{
        var _getDocument;
        // only disable tooltip when not on focus
        if (!((_getDocument = (0, $j5N6B.getDocument)()) !== null && _getDocument !== void 0 && (_getDocument = _getDocument.activeElement) !== null && _getDocument !== void 0 && _getDocument.contains(e.target))) e.stopPropagation();
    }, []);
    // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $fc4bM.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const imgAlt = isDecorative ? '' : emoji.name || emoji.shortName || '';
    const emojiNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("img", {
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        key: src,
        alt: imgAlt,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "emoji",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    });
    // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5P0Tk.DeletableEmojiTooltipContent), null),
        position: "right-start",
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gGEtj.EmojiNodeWrapper), {
        ...props,
        "aria-labelledby": `screenreader-emoji-${emoji.id}`,
        type: "image",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classes,
        ref: ref,
        showTooltip: false,
        onMouseOver: onMouseOver
    }, emojiNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9Mm2v.default), {
        onClick: (event)=>(0, $lmsyG.handleDelete)(props, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $e3Az2.DeletableEmojiTooltipContentForScreenReader), {
        emoji: emoji
    })));
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gGEtj.EmojiNodeWrapper), {
        ...props,
        type: "image",
        className: classes,
        ref: ref
    }, emojiNode));
};

});
parcelRegister("jeVzV", function(module, exports) {
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $a1dcd3843dc63083$export$b7e9058f156d8d19);

var $cZGOL = parcelRequire("cZGOL");
const $a1dcd3843dc63083$var$getHeight = (fitToHeight)=>(0, $cZGOL.getPixelRatio)() > 1 ? fitToHeight * 2 : fitToHeight;
const $a1dcd3843dc63083$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && emoji.representation && 'height' in emoji.representation && $a1dcd3843dc63083$var$getHeight(fitToHeight) > emoji.representation.height);

});

parcelRegister("e4RBv", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $a274b650a6c44480$export$2f62ee6831462844);

var $aKEsc = parcelRequire("aKEsc");

var $9H27G = parcelRequire("9H27G");
const $a274b650a6c44480$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $aKEsc.useInView)(options);
    if (!(0, $9H27G.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};

});
parcelRegister("aKEsc", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $7d3d94873b2ad301$export$2f62ee6831462844);

var $fc4bM = parcelRequire("fc4bM");
"use client";
var $7d3d94873b2ad301$var$__defProp = Object.defineProperty;
var $7d3d94873b2ad301$var$__defNormalProp = (obj, key, value)=>key in obj ? $7d3d94873b2ad301$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7d3d94873b2ad301$var$__publicField = (obj, key, value)=>$7d3d94873b2ad301$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/observe.ts
var $7d3d94873b2ad301$var$observerMap = /* @__PURE__ */ new Map();
var $7d3d94873b2ad301$var$RootIds = /* @__PURE__ */ new WeakMap();
var $7d3d94873b2ad301$var$rootId = 0;
var $7d3d94873b2ad301$var$unsupportedValue = void 0;
function $7d3d94873b2ad301$export$2ef3a60ee1f37bec(inView) {
    $7d3d94873b2ad301$var$unsupportedValue = inView;
}
function $7d3d94873b2ad301$var$getRootId(root) {
    if (!root) return "0";
    if ($7d3d94873b2ad301$var$RootIds.has(root)) return $7d3d94873b2ad301$var$RootIds.get(root);
    $7d3d94873b2ad301$var$rootId += 1;
    $7d3d94873b2ad301$var$RootIds.set(root, $7d3d94873b2ad301$var$rootId.toString());
    return $7d3d94873b2ad301$var$RootIds.get(root);
}
function $7d3d94873b2ad301$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $7d3d94873b2ad301$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $7d3d94873b2ad301$var$createObserver(options) {
    const id = $7d3d94873b2ad301$var$optionsToId(options);
    let instance = $7d3d94873b2ad301$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $7d3d94873b2ad301$var$observerMap.set(id, instance);
    }
    return instance;
}
function $7d3d94873b2ad301$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $7d3d94873b2ad301$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $7d3d94873b2ad301$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $7d3d94873b2ad301$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $7d3d94873b2ad301$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $7d3d94873b2ad301$export$a62107ca74432f44 = class extends $fc4bM.Component {
    constructor(props){
        super(props);
        $7d3d94873b2ad301$var$__publicField(this, "node", null);
        $7d3d94873b2ad301$var$__publicField(this, "_unobserveCb", null);
        $7d3d94873b2ad301$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $7d3d94873b2ad301$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$7d3d94873b2ad301$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $7d3d94873b2ad301$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $fc4bM.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function $7d3d94873b2ad301$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $fc4bM.useState(null);
    const callback = $fc4bM.useRef(onChange);
    const [state, setState] = $fc4bM.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $fc4bM.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $7d3d94873b2ad301$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $fc4bM.useRef(void 0);
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});

parcelRegister("9H27G", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccdbd74445e1a5be$export$2e2bcd8739ae039);
const $ccdbd74445e1a5be$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $ccdbd74445e1a5be$var$result.mac = /Mac/.test(navigator.platform);
    $ccdbd74445e1a5be$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $ccdbd74445e1a5be$export$2e2bcd8739ae039 = $ccdbd74445e1a5be$var$result;

});


parcelRegister("5P0Tk", function(module, exports) {
$parcel$export(module.exports, "DeletableEmojiTooltipContent", () => $e39702f5e3f40e70$export$4727956877b6f612);

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $hiqwk = parcelRequire("hiqwk");

var $1My73 = parcelRequire("1My73");

var $dVQhN = parcelRequire("dVQhN");
const $e39702f5e3f40e70$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dVQhN.ToolTipContentWithKeymap), {
        description: formatMessage((0, $1My73.messages).deleteEmojiTooltip),
        keymap: (0, $hiqwk.backspace)
    });
};

});
parcelRegister("hiqwk", function(module, exports) {
$parcel$export(module.exports, "backspace", () => $4f58aba1b9a61a40$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "arrowKeysMap", () => $4f58aba1b9a61a40$export$8d734690d3a46118);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $bFKC5 = parcelRequire("bFKC5");
const $4f58aba1b9a61a40$export$1ea584ca7009bcc1 = (0, $bFKC5.makeKeyMapWithCommon)('Backspace', 'Backspace');
const $4f58aba1b9a61a40$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};

});
parcelRegister("bFKC5", function(module, exports) {
$parcel$export(module.exports, "makeKeyMapWithCommon", () => $607b00a9a9a816df$export$7e6b588cc98b34f1);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $fNVnq = parcelRequire("fNVnq");
function $607b00a9a9a816df$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return (0, $fNVnq.makeKeymap)(description, windows, mac, common);
}

});
parcelRegister("fNVnq", function(module, exports) {
$parcel$export(module.exports, "makeKeymap", () => $1b8800244b338052$export$d8a7f422d8d42038);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ function $1b8800244b338052$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}

});



parcelRegister("dVQhN", function(module, exports) {
$parcel$export(module.exports, "ToolTipContentWithKeymap", () => $92b6b50d81a00f16$export$c7308f5f9ed494ac);
/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $6hL0j = parcelRequire("6hL0j");
const $92b6b50d81a00f16$var$tooltipShortcutStyle = null;
const $92b6b50d81a00f16$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $6hL0j.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        className: (0, $2R2iS.default)([
            "_2rkofajl _bfhk1vck _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"
        ])
    }, shortcut)) : null;
});

});
parcelRegister("6hL0j", function(module, exports) {
$parcel$export(module.exports, "formatShortcut", () => $2a0758c03c27a781$export$384a290f8c265cc5);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $9H27G = parcelRequire("9H27G");

var $hiqwk = parcelRequire("hiqwk");
function $2a0758c03c27a781$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $9H27G.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = (0, $hiqwk.arrowKeysMap)[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $9H27G.default).mac ? '' : '+');
}

});



parcelRegister("e3Az2", function(module, exports) {
$parcel$export(module.exports, "DeletableEmojiTooltipContentForScreenReader", () => $cf547bf59a0deaf4$export$d151e4941072147c);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $dVxDa = parcelRequire("dVxDa");

var $1My73 = parcelRequire("1My73");
const $cf547bf59a0deaf4$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dVxDa.default), {
        id: `screenreader-emoji-${emoji.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...(0, $1My73.messages).deleteEmojiTooltipForScreenreader,
        values: {
            shortName: emoji.shortName
        }
    }));
};

});

parcelRegister("9Mm2v", function(module, exports) {
$parcel$export(module.exports, "default", () => $11ceaf2f17a96ffc$export$2e2bcd8739ae039);
/* DeleteButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $kTVlm = parcelRequire("kTVlm");

var $48hlF = parcelRequire("48hlF");

var $dBtOK = parcelRequire("dBtOK");

var $5av15 = parcelRequire("5av15");

var $coQxr = parcelRequire("coQxr");
const $11ceaf2f17a96ffc$var$styles = {
    boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
const $11ceaf2f17a96ffc$var$deleteButton = null;
const $11ceaf2f17a96ffc$var$refreshedDeleteButton = null;
const $11ceaf2f17a96ffc$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $11ceaf2f17a96ffc$var$DeleteButton = (props)=>{
    return /*#__PURE__*/ $fc4bM.createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            "_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf",
            "_154ir5cr _1xi2r5cr",
            (0, $coQxr.emojiDeleteButton)
        ]),
        "data-testid": $11ceaf2f17a96ffc$export$28fc7374cf1206d4
    }, /*#__PURE__*/ $fc4bM.createElement((0, $kTVlm.default), {
        iconBefore: /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
            xcss: $11ceaf2f17a96ffc$var$styles.boxWrapperStyle
        }, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($48hlF))), {
            label: (0, $5av15.deleteEmojiLabel),
            color: "var(--ds-icon, #292A2E)",
            size: "medium"
        })),
        onClick: props.onClick,
        // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
        appearance: "subtle-link",
        spacing: "none",
        testId: "emoji-delete-button",
        tabIndex: -1
    }));
};
var $11ceaf2f17a96ffc$export$2e2bcd8739ae039 = $11ceaf2f17a96ffc$var$DeleteButton;

});


parcelRegister("hWZeB", function(module, exports) {
$parcel$export(module.exports, "SpriteEmoji", () => $6c3f5bf4c0578369$export$ef49ddbb198ce334);
/* SpriteEmoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $aEmSo = parcelRequire("aEmSo");

var $gGEtj = parcelRequire("gGEtj");

var $coQxr = parcelRequire("coQxr");
const $6c3f5bf4c0578369$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $coQxr.emojiNodeStyles)} ${selected ? (0, $coQxr.commonSelectedStyles) : ''} ${selectOnHover ? (0, $coQxr.selectOnHoverStyles) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) {
        if ((0, $aEmSo.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) sizing = {
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
        else sizing = {
            width: `${fitToHeight}px`,
            height: `${fitToHeight}px`,
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
    }
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ $fc4bM.createElement((0, $gGEtj.EmojiNodeWrapper), {
        ...props,
        type: "sprite",
        className: classes
    }, /*#__PURE__*/ $fc4bM.createElement("span", {
        className: (0, $coQxr.emojiSprite),
        style: style
    })));
};

});


parcelRegister("gV0vd", function(module, exports) {
$parcel$export(module.exports, "default", () => $68e7b4f5757536a8$export$2e2bcd8739ae039);
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ /* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $aEmSo = parcelRequire("aEmSo");

var $5av15 = parcelRequire("5av15");

var $ahRlw = parcelRequire("ahRlw");

var $coQxr = parcelRequire("coQxr");
const $68e7b4f5757536a8$var$placeholderContainer = null;
const $68e7b4f5757536a8$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $5av15.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false, xcss: xcss } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = (0, $aEmSo.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? {
        fill: 'f7f7f7',
        minWidth: `${0, $5av15.defaultDenseEmojiHeight}px`,
        minHeight: `${0, $5av15.defaultDenseEmojiHeight}px`
    } : {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ $fc4bM.createElement("span", {
        "data-testid": (0, $ahRlw.emojiPlaceholderTestId)(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _2rkofajl _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _bfhk1l7x _s7n4nkob _o5721q9c _y3gn1h6o",
            [
                (0, $coQxr.placeholder),
                xcss
            ].join(' ')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $68e7b4f5757536a8$export$2e2bcd8739ae039 = $68e7b4f5757536a8$var$EmojiPlaceholder;

});
parcelRegister("ahRlw", function(module, exports) {
$parcel$export(module.exports, "emojiPlaceholderTestId", () => $46f4e8f52aca8fc5$export$73987987fac5266b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $46f4e8f52aca8fc5$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;

});



parcelRegister("ln1kt", function(module, exports) {
$parcel$export(module.exports, "UfoErrorBoundary", () => $4310311d59bccd88$export$5ef1c2550074a375);

var $fc4bM = parcelRequire("fc4bM");
class $4310311d59bccd88$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}

});



//# sourceMappingURL=shared.885b3e5e.js.map
